import request from '@/utils/request';


/**
 * 获取当前老师指定日期排课日历数据
 */
export async function getAppointDayTeacherSchedule(params: any) {
  return request('/crm-teaching/foreignTeacher/getAppointDayTeacherSchedule', {
    method: 'GET',
    params,
  });
}

/**
 * 更新排课日历
 */
export async function updateOpenBookDemo(params: any) {
  return request('/crm-teaching/foreignTeacher/updateOpenBookDemo', {
    method: 'POST',
    data: params,
  });
}